import React from "react"

import {CloseIcon} from "./styled"

export interface Props {
  onClick: () => void
  top?: string
  right?: string
  inline?: boolean
  color?: string
  id?: string
}

const Close = ({...props}: Props) => <CloseIcon {...props} />

export default Close
